// extracted by mini-css-extract-plugin
export default {"taskSummaryText":"GoalGridSummary_taskSummaryText__Vzip-"};